import { useState, useEffect } from 'react';
import axiosInstance from '../utilities/request-utility';


const useFetch = (initialUrl, initialParams = {}, skip = false) => {
  const [url, updateUrl] = useState(initialUrl);
  const [params, updateParams] = useState(initialParams);
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [refetchIndex, setRefetchIndex] = useState(0);

  const refetch = () => setRefetchIndex((prev) => prev + 1);

  useEffect(() => {
    const fetchData = async () => {
      if (skip) return;
      setIsLoading(true);
      setHasError(false);
      setErrorMessage('');
      
      try {
        const response = await axiosInstance().get(url, { params });
        setData(response.data);
      } catch (err) {
        setHasError(true);
        setErrorMessage(err.response?.data || err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [url, params, refetchIndex]);

  return { data, isLoading, hasError, errorMessage, updateUrl, updateParams, refetch };
};

export default useFetch;